import type { ContentItem } from "@/types/content";

export const entertainmentNews: ContentItem[] = [
  {
    id: "en-01",
    category: "entertainment-news",
    title: "年度盛典红毯星光熠熠，众多艺人造型引发热议",
    summary:
      "今年的年度娱乐盛典如期举行，红毯现场星光汇聚，多套造型成为社交平台讨论焦点，网友直呼看点十足。",
    cover:
      "https://readdy.ai/api/search-image?query=glamorous%20red%20carpet%20event%20with%20warm%20spotlights%20and%20elegant%20stage%2C%20festive%20red%20and%20gold%20tone%2C%20editorial%20photography&width=800&height=520&seq=en01-cover&orientation=landscape",
    author: "红桃网娱乐组",
    date: "2026-10-10",
    heat: 96,
    content:
      "<p>一年一度的娱乐盛典近日落下帷幕，红毯环节成为全场关注的焦点。众多艺人陆续亮相，风格各异的造型在社交平台引发热烈讨论，相关话题迅速登上热搜榜。</p><p>今年的红毯整体色调偏向暖红与暖金，配合现场灯光设计，营造出隆重而热烈的氛围。不少观众表示，今年的造型整体水准在线。</p><h3>现场互动亮点多</h3><p>除红毯外，盛典现场的舞台表演与颁奖环节同样精彩。多位艺人带来了精心准备的节目，场内外互动频繁。</p><p>红桃网将持续带来盛典的完整回顾与幕后花絮。</p>",
  },
  {
    id: "en-02",
    category: "entertainment-news",
    title: "热门综艺新一季官宣阵容，嘉宾组合新鲜感十足",
    summary:
      "备受关注的热门综艺官宣新一季常驻阵容，全新嘉宾组合带来不一样的化学反应，节目组透露赛制也将升级。",
    cover:
      "https://readdy.ai/api/search-image?query=bright%20colorful%20tv%20studio%20set%20for%20a%20variety%20show%2C%20playful%20props%20and%20warm%20stage%20lighting%2C%20energetic%20tone&width=800&height=520&seq=en02-cover&orientation=landscape",
    author: "红桃网娱乐组",
    date: "2026-10-08",
    heat: 90,
    content:
      "<p>热门综艺节目正式官宣新一季常驻嘉宾阵容，全新组合一经公布便引发讨论。节目组表示，本季在赛制与环节设计上做了较大调整，希望给观众带来新鲜体验。</p><p>据透露，新一季将增加更多户外实景拍摄，嘉宾之间的协作与对抗也会更加激烈。</p><h3>观众期待值拉满</h3><p>不少观众留言表示，新阵容的搭配让人眼前一亮，期待节目正式开播。</p><p>节目预计将于近期上线，红桃网将持续跟进相关资讯。</p>",
  },
  {
    id: "en-03",
    category: "entertainment-news",
    title: "实力派歌手宣布全新巡演计划，首站门票关注度高",
    summary:
      "某实力派歌手正式公布全新巡回演唱会计划，首站演出信息一经发布便获得大量关注，歌迷期待值高涨。",
    cover:
      "https://readdy.ai/api/search-image?query=concert%20stage%20with%20warm%20red%20spotlights%20and%20silhouette%20of%20a%20performer%2C%20atmospheric%20live%20music%20tone%2C%20cinematic&width=800&height=520&seq=en03-cover&orientation=landscape",
    author: "红桃网娱乐组",
    date: "2026-10-06",
    heat: 86,
    content:
      "<p>某实力派歌手正式公布全新巡回演唱会计划，涵盖多个城市。首站演出信息发布后，相关话题迅速升温，歌迷纷纷表示期待。</p><p>据悉，本轮巡演在舞台设计与歌单编排上都做了全新尝试，将加入更多现场乐队元素。</p><h3>歌单看点</h3><p>制作团队透露，巡演将兼顾经典曲目与新作，力求为不同年代的歌迷带来共鸣。</p><p>更多场次信息将陆续公布，敬请关注红桃网。</p>",
  },
  {
    id: "en-04",
    category: "entertainment-news",
    title: "多位演员官宣新剧合作，题材覆盖现实与古装",
    summary:
      "近期多位演员接连官宣新剧合作，题材横跨现实题材与古装剧集，行业呈现出内容多元、题材丰富的态势。",
    cover:
      "https://readdy.ai/api/search-image?query=film%20clapperboard%20and%20script%20on%20a%20table%20with%20warm%20lighting%2C%20behind%20the%20scenes%20vibe%2C%20editorial%20tone&width=800&height=520&seq=en04-cover&orientation=landscape",
    author: "红桃网娱乐组",
    date: "2026-10-04",
    heat: 82,
    content:
      "<p>近期多位演员接连官宣新剧合作，涵盖现实题材、都市情感与古装剧集等多种类型。行业观察人士认为，题材的多元化有助于满足观众日益细分的内容需求。</p><p>部分剧组已进入筹备阶段，有的则刚刚完成开机仪式，整体进度各有不同。</p><h3>题材更趋丰富</h3><p>从已公布的信息看，现实题材与古装大剧依旧是热门方向，同时也有不少创新尝试。</p><p>红桃网将持续更新各剧集的拍摄与播出动态。</p>",
  },
  {
    id: "en-05",
    category: "entertainment-news",
    title: "音乐节阵容公布，多组乐队带来跨界合作舞台",
    summary:
      "本届音乐节公布完整阵容，多组知名乐队与音乐人确认参演，部分跨界合作舞台成为最大看点。",
    cover:
      "https://readdy.ai/api/search-image?query=outdoor%20music%20festival%20crowd%20at%20sunset%20with%20stage%20lights%2C%20warm%20orange%20sky%2C%20energetic%20atmosphere&width=800&height=520&seq=en05-cover&orientation=landscape",
    author: "红桃网娱乐组",
    date: "2026-10-02",
    heat: 78,
    content:
      "<p>本届音乐节正式公布完整演出阵容，多组知名乐队与独立音乐人确认参演。主办方表示，今年特别设置了跨界合作舞台，希望带来耳目一新的现场体验。</p><p>音乐节将设置多个舞台，覆盖摇滚、民谣、电子等多种风格，满足不同乐迷的偏好。</p><h3>现场体验升级</h3><p>除演出外，现场还规划了市集与互动区域，力求打造完整的音乐节日体验。</p><p>门票与场次信息以主办方公布为准，红桃网将持续关注。</p>",
  },
  {
    id: "en-06",
    category: "entertainment-news",
    title: "综艺市场新趋势：慢节奏内容受年轻观众青睐",
    summary:
      "近期多档慢节奏生活类综艺表现亮眼，内容取向更注重情感陪伴与真实记录，受到年轻观众群体的喜爱。",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20warm%20living%20space%20with%20soft%20evening%20light%20and%20plants%2C%20relaxed%20lifestyle%20mood%2C%20warm%20neutral%20tone&width=800&height=520&seq=en06-cover&orientation=landscape",
    author: "红桃网娱乐组",
    date: "2026-09-29",
    heat: 72,
    content:
      "<p>近期多档慢节奏生活类综艺表现亮眼，这类节目注重真实记录与情感陪伴，节奏舒缓、氛围轻松，受到不少年轻观众的青睐。</p><p>有分析认为，在快节奏生活压力下，观众更愿意通过这类内容获得放松与治愈。</p><h3>内容取向变化</h3><p>相比强情节与强冲突，慢综艺更强调日常感与真实感，这也对制作团队提出了新的要求。</p><p>红桃网将持续关注综艺市场的内容趋势。</p>",
  },
  {
    id: "en-07",
    category: "entertainment-news",
    title: "舞台剧巡演加场，经典 IP 改编收获口碑",
    summary:
      "由经典 IP 改编的舞台剧开启全国巡演，因口碑良好而多次加场，舞台呈现与音乐设计获得观众一致好评。",
    cover:
      "https://readdy.ai/api/search-image?query=theatre%20stage%20with%20warm%20dramatic%20red%20curtain%20and%20soft%20spotlight%2C%20classic%20performance%20atmosphere%2C%20cinematic&width=800&height=520&seq=en07-cover&orientation=landscape",
    author: "红桃网娱乐组",
    date: "2026-09-27",
    heat: 68,
    content:
      "<p>由经典 IP 改编的舞台剧正式开启全国巡演，凭借扎实的剧本与用心的舞台呈现，演出收获良好口碑，多地因此追加场次。</p><p>主创团队表示，改编过程中既保留了原作的经典桥段，也加入了适合舞台表达的创新设计。</p><h3>舞台与音乐亮点</h3><p>舞美设计与现场音乐成为观众讨论较多的部分，为剧情推进增色不少。</p><p>更多巡演城市信息将持续更新，敬请关注红桃网。</p>",
  },
];